import { FONT_SIZE, INK, LETTER_SPACING } from "../../../../theme/tokens";

/** The drawer's micro label — a notch under the sheets' eyebrow, since it sits in a two-up grid of figures. */
export const METRIC_LABEL_SX = {
	fontSize: FONT_SIZE.LABEL_MICRO,
	letterSpacing: LETTER_SPACING.LABEL,
	textTransform: "uppercase",
	fontWeight: 600,
	color: INK.MUTED,
} as const;

/**
 * A figure in the drawer: tabular, so a column of them lines up, and never broken across lines — "1.62 / 3" split into
 * "1.62 /" over "3" reads as two numbers. Beside a label, the label is what wraps.
 */
export const METRIC_VALUE_SX = {
	fontSize: FONT_SIZE.LABEL_SM,
	fontWeight: 600,
	color: INK.PRIMARY,
	fontVariantNumeric: "tabular-nums",
	whiteSpace: "nowrap",
} as const;
